import { updatesItems } from '@/mocks/homeData';

const tagStyleMap: Record<string, string> = {
  '公告': 'bg-primary-100 text-primary-700',
  '新赛道': 'bg-accent-100 text-accent-800',
  '热门': 'bg-red-100 text-red-600',
  '活动': 'bg-secondary-100 text-secondary-700',
  '榜单': 'bg-amber-100 text-amber-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            每日大赛mrds平台动态、赛事更新和社区热门资讯
          </p>

          <div className="relative">
            <div className="absolute left-4 top-2 bottom-2 w-px bg-background-300"></div>

            <div className="space-y-0">
              {updatesItems.map((item, idx) => (
                <div key={idx} className="relative flex items-start gap-5 pb-6 last:pb-0">
                  <div className="relative z-10 w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full bg-background-50 border-2 border-background-300 mt-0.5">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1.5">
                      <span className="text-xs text-foreground-400">{item.time}</span>
                      <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${tagStyleMap[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="font-heading font-semibold text-sm text-foreground-900 leading-relaxed">
                      {item.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}